import select2 from 'select2';

export default function initializeOfficesSearch() {
    initializeOfficesSelect();
}

function initializeOfficesSelect() {
    let select = $('#offices-select').select2({
        language: 'pl',
        minimumResultsForSearch: Infinity
    });

    select.on('select2:select', function (e) {
        if (e.params.data.id !== 'all') {
            window.location.href = e.params.data.element.dataset.link;
        }
    });
}